import { isServer } from '@proj-common/utils' 
import Cookies from 'js-cookie'

export class TrackingEvent {
    object: string
    action: string
    properties: any
    constructor(object: TrackingEvent.Object) {
        this.object = TrackingEvent.Object[object]
    }
    getEventType() {
        return this.object + "-" + this.action
    }
    getEventProperties() {
        return this.properties
    }
    getEventPropertiesString() {
        let eventProperties = ""
        // property valued are listed in the keys' alphabetical order
        if (this.properties) {
            Object.entries(this.properties).sort((a, b) => b[0].localeCompare(a[0]))
            for (const [key, value] of Object.entries(this.properties)) {
                eventProperties = eventProperties + (value ? value : "null") + "--"
            }
            eventProperties = eventProperties.slice(0, -2)
        }
        return eventProperties
    }
}

export namespace TrackingEvent {
    export enum Object {
        Contact,
        Event,
        Idea,
        IdeaGroup,
        Payment,
        Participant
    }
}

export class ContactObject extends TrackingEvent {
    constructor(action: ContactObject.Action) {
        super(TrackingEvent.Object.Contact)
        this.action = ContactObject.Action[action];
    }
}
export namespace ContactObject {
    export enum Action {
        Started,
        JoinNewsletter,
    }
}

export class EventObject extends TrackingEvent {
    constructor(action: EventObject.Action, stage: string, step: string, template: string) {
        super(TrackingEvent.Object.Event)
        this.action = EventObject.Action[action]
        this.properties = {
            stage: stage,
            step: step,
            template: template
        }
    }
}
export namespace EventObject {
    export enum Action {
        SignupStarted,
        Created,
        UnlockStarted,
        InviteCopied,
        Started,
        NextStage,
        NextStep,
        ResultsCopied,
        Completed,
        SortByTime,
        SortByPerson,
        Error400,
        Error401,
        Error403,
        Error404,
        Error500,
        Error
    }
}

export class IdeaObject extends TrackingEvent {
    constructor(action: IdeaObject.Action, stage: string, step: string, template: string) {
        super(TrackingEvent.Object.Idea)
        this.action = IdeaObject.Action[action]
        this.properties = {
            stage: stage,
            step: step,
            template: template
        }
    }
}
export namespace IdeaObject {
    export enum Action {
        AddStarted,
        AddCompleted,
        AddCancelled,
        Deleted,
        UpvoteAdded,
        UpvoteRemoved
    }
}

export class IdeaGroupObject extends TrackingEvent {
    constructor(action: IdeaGroupObject.Action, ideaCount: number) {
        super(TrackingEvent.Object.IdeaGroup)
        this.action = IdeaGroupObject.Action[action]
        this.properties = {
            ideaCount: ideaCount
        }
    }
}
export namespace IdeaGroupObject {
    export enum Action {
        CreationStarted,
        CreationCompleted,
        CreationCancelled
    }
}

export class PaymentObject extends TrackingEvent {
    constructor(action: PaymentObject.Action, couponCode: string) {
        super(TrackingEvent.Object.Payment)
        this.action = PaymentObject.Action[action]
        this.properties = {
            couponCode: couponCode
        }
    }
}
export namespace PaymentObject {
    export enum Action {
        Started,
        Completed,
        Failed
    }
}

export class ParticipantObject extends TrackingEvent {
    constructor(action: ParticipantObject.Action) {
        super(TrackingEvent.Object.Participant)
        this.action = PaymentObject.Action[action]
    }
}
export namespace ParticipantObject {
    export enum Action {
        JoinInitiated
    }
}

var isAmplitudeInitialized = false

export const trackEvent = (event: TrackingEvent) => {
    //if (SiteDeploymentType() == 'production') {
    if (!isServer) {
        if (Cookies.get('cookie-analytics') == 'true') {
            import('amplitude-js').then((amplitudeInstance) => {
                //TODO: remove test warn console log
                console.warn("Analytics Event: ", event.getEventType(), event.getEventPropertiesString(), event.getEventProperties())
                //@ts-expect-error
                window.umami?.trackEvent(event.getEventPropertiesString(), event.getEventType())

                if (amplitudeInstance) {
                    if (!isAmplitudeInitialized) {
                        amplitudeInstance.default.getInstance().init("4bcb47f849d496ad2001b2052b034b83")
                        isAmplitudeInitialized = true
                    }
                    // TODO: doesn't work here..
                    amplitudeInstance.default.logEvent(event.getEventType(), event.getEventProperties())
                }
            })
        }
    }
    //}
}